var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8162 23.3453L15.1841 24.9774C12.9306 27.2309 9.27706 27.2309 7.02359 24.9774C4.77013 22.724 4.77013 19.0704 7.02359 16.8169L8.6557 15.1848",
    stroke: "#F0002E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 20.0394L20.0394 11.9609",
    stroke: "#F0002E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3456 16.816L24.9777 15.1839C27.2311 12.9304 27.2311 9.27681 24.9777 7.02335C22.7242 4.76989 19.0706 4.76989 16.8172 7.02335L15.1851 8.65545",
    stroke: "#F0002E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkShare);
export default __webpack_public_path__ + "static/media/linkShare.0d9980cb4605dba53052aac1290210fc.svg";
export { ForwardRef as ReactComponent };